import { useState, useEffect } from "react";

const BREAKPOINTS = {
  xs: 991, // xs and sm will share this breakpoint
  lg: 1024,
  xl: 1280,
};

const useScreenSize = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    width: windowSize.width,
    height: windowSize.height,
    isXs: windowSize.width < BREAKPOINTS.xs, // xs and sm share the same range
    // windowSize.width >= BREAKPOINTS.md && windowSize.width < BREAKPOINTS.lg,
    isLg:
      windowSize.width >= BREAKPOINTS.lg && windowSize.width < BREAKPOINTS.xl,
    isXl: windowSize.width >= BREAKPOINTS.xl,
  };
};

export default useScreenSize;
